export const pricePointOptions = [1, 2, 3, 4];
